import FormRow from "components/form/FormRow";
import ListInput from "components/form/input/ListInput";
import TextInput from "components/form/input/TextInput";
import { CompareSymbolSelectInput, GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import TMM from "..";
import SelectInput from "components/form/input/SelectInput";

export function TMMParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={TMM.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta">
                        <TextInput name="mecanizado.meta" label="Meta (mm:ss)" mask="00:00" />
                    </ParamFormRow>

                    <FormRow sx={{ p: 2, pl: { xs: 0, sm: 2 }, pr: { xs: 0, sm: 2 } }}>
                        <ListInput name="items" label="Pontos Amostrados">
                            <SelectInput
                                sx={{ flex: 0.5 }}
                                name="classificacao"
                                label="Classificação"
                                options={["Ótimo",
                                    "Bom",
                                    "Regular",
                                    "Ruim"
                                ]}
                            />
                            <CompareSymbolSelectInput name="sinalIntervaloMin" label="Sinal" />
                            <TextInput name="intervaloMin" label="Intervalo (Mín.)" mask="00:00" />
                            <CompareSymbolSelectInput name="sinalIntervaloMax" label="Sinal" />
                            <TextInput name="intervaloMax" label="Intervalo (Máx.)" mask="00:00" />
                        </ListInput>
                    </FormRow>
                </>
            }
        />
    );
}
